import { Component } from '@angular/core';

@Component({
  selector: 'app-order-details-events-timeline',
  templateUrl: './order-details-events-timeline.component.html',
  styleUrls: ['./order-details-events-timeline.component.scss']
})
export class OrderDetailsEventsTimelineComponent {

}
